import { render, staticRenderFns } from "./DividedSidebarList.vue?vue&type=template&id=71e750f0"
import script from "./DividedSidebarList.vue?vue&type=script&lang=js"
export * from "./DividedSidebarList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports